import { combineReducers } from 'redux';
import activePopup from './activePopup';
import isEditingPopup from './isEditingPopup';
import isPopupAttachedToMouse from './isPopupAttachedToMouse';
import popups from './popups';
import zIndex from './zIndex';

const basePopupReducer = combineReducers({
  activePopup,
  isEditingPopup,
  isPopupAttachedToMouse,
  popups,
  zIndex,
});

const popupReducer = (state, action) => basePopupReducer(state, { ...action, state });

export default popupReducer;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupsReducer/index.jsx